import { call, put, takeLatest } from 'redux-saga/effects'

import { postMachine, putMachine, deleteMachine } from '@galo-monitor/services/apis/galoMonitorApi/resources/machine'

import { MachineActions, MachineTypes } from './duckMachine'

function* saveMachine({ machine, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(machine.id ? putMachine : postMachine , machine)
    yield call(onSuccess)
  } catch (err) {
    yield put(MachineActions.machineError(err.message))
    yield call(onError, err)
  }
}

function* removeMachine({ machine, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteMachine, machine)
    yield call(onSuccess)
  } catch (err) {
    yield put(MachineActions.machineError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(MachineTypes.SAVE_MACHINE, saveMachine),
  takeLatest(MachineTypes.REMOVE_MACHINE, removeMachine)
]
